import {Group} from '@mantine/core';
import {IconInfoCircle} from '@tabler/icons-react';
import type {FC} from 'react';
import {Description} from 'src/design/atoms/Description';

/**
 * Inline info-circle icon paired with small dimmed helper text.
 * @registry Inline helper text with a leading info-circle icon.
 *
 * Ported from `library/elements/HelpText`. Prop surface kept identical.
 */
export interface HelpTextProps {
  text: string;
}

export const HelpText: FC<HelpTextProps> = ({text}) => {
  return (
    <Group gap="xs">
      <IconInfoCircle size={16} />
      <Description size="xs" text={text} mt={0} />
    </Group>
  );
};
